<template>
    <div>
        <WorkplacePreferencesItem
            v-if="workplacePreferences.isRemoteOnly"
            icon="home"
            :title="t('profile.section.workplace.preferences.remote.title')"
            :label="t('profile.preferences.section.work_place.remote.label')"
            data-test-id="profile-workplace-preferences-remote-only-container"
        />
        <VJoyWrapper v-else no-margin wrap="wrap" direction="column" align="flex-start" row-gap="4" column-gap="8">
            <WorkplacePreferencesItem
                icon="walk"
                :title="t('profile.section.workplace.preferences.onsite.title')"
                :label="workplaceLabel"
                data-test-id="profile-workplace-preferences-on-site-container"
            />
            <WorkplacePreferencesItem
                v-if="isStrategyProfile && workplacePreferences.isWillingToTravelInternationally"
                icon="transportation"
                :title="t('profile.section.travel.preferences.title')"
                data-test-id="profile-location-preference-travel-container"
            />
        </VJoyWrapper>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyWrapper} from '@maltjoy/core-vue';
    import type {WorkplaceLocation, WorkplacePreferences} from '~/components/_common/location-and-workplace-preferences/WorkplacePreferences';
    import WorkplacePreferencesItem from '~/components/_common/location-and-workplace-preferences/WorkplacePreferencesItem.vue';

    const {t} = useTranslation();

    const props = defineProps<{
        workplacePreferences: WorkplacePreferences;
        isStrategyProfile: boolean;
    }>();

    const cities = computed<WorkplaceLocation[]>(() => [
        props.workplacePreferences.mainCity,
        ...props.workplacePreferences.alternativeWorkplaceLocations,
    ]);

    const workplaceLabel = computed(() =>
        cities.value
            .map((city) =>
                t('profile.section.workplace.preferences.onsite.label.city', {
                    0: city.city,
                    1: city.radius,
                }),
            )
            .join(', '),
    );
</script>
